import { render, staticRenderFns } from "./RollersElectricMotor.vue?vue&type=template&id=620e8200&scoped=true&"
import script from "./RollersElectricMotor.vue?vue&type=script&lang=js&"
export * from "./RollersElectricMotor.vue?vue&type=script&lang=js&"
import style0 from "./RollersElectricMotor.vue?vue&type=style&index=0&id=620e8200&scoped=true&lang=css&"
import style1 from "./RollersElectricMotor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e8200",
  null
  
)

export default component.exports